import React, { useEffect, useMemo, useState } from "react";
import clsx from "clsx";
// Material
import Typography from "@material-ui/core/Typography";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
// Components
import ChoiceItem from "./../ChoiceItem/ChoiceItem";
// Icons
import ExpandLessOutlinedIcon from "@material-ui/icons/ExpandLessOutlined";
import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";
// Controls
import Btn from "./../Controls/Button/Button";
import Modal from "./../Material/Modal/Modal";
// Custom Hooks
import useDynamicHotelData from "../../CustomHooks/useDynamicHotelData";
import useCheckoutForm from "../../CustomHooks/useCheckoutForm";
// Styles
import useStyles from "./FilterBar.style.js";
import { generateDateSlots, getTimeIntervalSlots } from "../../utils/utils";
import { useSelector, useDispatch } from "react-redux";
import { SORT_OPTIONS } from "../../utils/Constants";
import useSortMainHook from "../../CustomHooks/useSortMainHook";
import { setNextAvailableTime } from "../../store/Time/TimeAction";
import moment from "moment";
import Menu from "../Menu/Menu";
import CategoryModal from "../CategoryModal/CategoryModal";
import { useRef } from "react";
import * as _ from "lodash";
import {
  Button,
  InputBase,
  Paper,
  TextField,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import List from "@material-ui/icons/List.js";
import {
  getMenuCategoryList,
  onSearchMenu,
  removeActiveCategory,
} from "../../store/Menu/MenuActions";
import useSortHook from "../../CustomHooks/useSortHook.js";
import SearchIcon from "@material-ui/icons/Search";
import SelectOrderType from "../Checkout/SelectOrderType/SelectOrderType.js";
import SelectOrderTypeUI from "../Checkout/SelectOrderType/SelectOrderTypeUI.js";
import ModalComponent from "./../Material/Modal/Modal";
import { clearLocation } from "../../store/Location/LocationActions.js";
import { clearCoupon } from "../../store/Cart/CartActions.js";
import { resetWallet } from "../../store/Profile/ProfileActions.js";
import useWalletPoints from "../../CustomHooks/useWalletPoints.js";
import { dispatchErrorMessageAsWarning } from "../../utils/Shared.js";

const TYPES = {
  ORDER_TYPE: "ORDER_TYPE",
  PAYMENT_METHOD: "PAYMENT_METHOD",
};

const FilterBar = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { FType, handleFilter } = useSortMainHook();
  const [drawer, toggleDrawer] = useState(false);
  const menu = useSelector((state) => state.menu);
  const [filterDrawer, toggleFilterDrawer] = useState(false);
  const [filterOrderType, setFilterOrderType] = useState("");
  const [openModal, setModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [nextAvailable, setNextAvailable] = useState("");
  const { getOrderTypes, getPaymentMethods } = useDynamicHotelData();
  const { formValues, setFormValues } = useCheckoutForm();
  const { hotel, tableId } = useSelector((state) => state.hotel);
  const { cart } = useSelector((state) => state);
  const { nextAvailableTime } = useSelector((state) => state.time);
  // console.log("next availble time", nextAvailableTime)
  const [isCollapse, setIsCollapse] = useState(false);
  const [orderTypeModal, setOrderTypeModal] = useState(false);
  const theme = useTheme();
  const [isSearchBarVisible, setSearchBarVisible] = useState(false);
  const isMobile = useMediaQuery("(max-width:495px)");
  const {
    formatDateToCheck,
    checkComboCatAvailability,
    checkProductAvailability,
    checkGroupedAvailability,
    checkCategoryAndProductAvailability,
  } = useSortHook();
  const [currentTime, setCurrentTime] = useState(moment()); // Initialize current time using moment
  const [activeItem, setActiveItem] = useState(null);
  const itemRefs = useRef({});
  const { resetWalletProducts, RemoveItemCoupon } = useWalletPoints();

  const [searchPhrase, setSearchPhrase] = useState("");
  const containerRef = useRef(null);
  const previousActive = useMemo(
    () => menu?.activeCategory,
    [menu?.activeCategory]
  );

  // ✅ Sync local search with global search state
  useEffect(() => {
    // If global search is cleared, clear local search as well
    if (!menu?.searchPhrase || menu?.searchPhrase.trim() === "") {
      setSearchPhrase("");
    }
  }, [menu?.searchPhrase]);

  useEffect(() => {
    if (menu?.activeCategory) {
      setActiveItem(menu.activeCategory);
    } else {
      setActiveItem(null);
    }
  }, [menu?.activeCategory]);

  useEffect(() => {
    // Scroll to active item when it changes

    if (containerRef.current && activeItem) {
      const activeElement = containerRef.current.querySelector(
        `[data-id="${activeItem}"]`
      );
      if (activeElement) {
        if (activeElement) {
          const containerRect = containerRef.current.getBoundingClientRect();
          const activeRect = activeElement.getBoundingClientRect();
          const scrollLeft =
            activeRect.left -
            containerRect.left +
            containerRef.current.scrollLeft;
          containerRef.current.scrollTo({
            left: scrollLeft,
            behavior: "smooth",
          });
        }
      }
    }
  }, [activeItem]);

  // function isMobile() {
  //   return window.innerWidth <= 768; // You can adjust the breakpoint as needed
  // }

  // console.log("ismobileeeeeeeeee", isMobile);

  // Update current time every second using useEffect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, 1000);

    // Clear interval on component unmount
    return () => clearInterval(interval);
  }, []);
  const selectedOrderType = useMemo(() => {
    if (getOrderTypes?.length === 1) {
      setFormValues({ orderType: getOrderTypes[0]?.type });
      const data = getOrderTypes[0]?.title;
      return data;
    } else if (getOrderTypes?.length > 1) {
      const data = getOrderTypes.find((o) => o.type === formValues.orderType);
      return data ? data.title : "";
    } else {
      setFormValues({ orderType: null });
    }
    // return data ? data.title : "";
  }, [formValues.orderType, getOrderTypes]);

  //order filter
  const onOpenDrawer = (type) => {
    setFilterOrderType(type);
    toggleDrawer(true);
  };
  const applyOrderFilter = (fieldName, val) => {
    setFormValues({ [fieldName]: val });
    localStorage.setItem("orderType", val);
    toggleDrawer(false);
  };
  //filter
  const onOpenFilterDrawer = (type) => {
    toggleFilterDrawer(true);
  };
  const applyFilter = (val) => {
    handleFilter(val);
    toggleFilterDrawer(false);
  };

  const setMenuCategory = (categoryId) => {
    // console.log("category iddddddddd",categoryId)
    dispatch(removeActiveCategory());
    dispatch(getMenuCategoryList(categoryId));
  };

  const onSearch = (e) => {
    const searchF = _.debounce(
      () => dispatch(onSearchMenu(e.target.value)),
      1000
    );
    setSearchPhrase(e.target.value);
    searchF();
  };

  useEffect(() => {
    const dates = generateDateSlots(hotel, formValues.orderType) || [];
    const timeSlots =
      (dates?.length &&
        getTimeIntervalSlots(hotel, cart, formValues, dates[0].date)) ||
      [];
    if (dates.length && timeSlots.length) {
      const nextSlot = `${dates[0].label} ${timeSlots[0].label}`;

      // const nextSlot = dates
      // setNextAvailable(nextSlot);
      dispatch(setNextAvailableTime(nextSlot));
    }
  }, [formValues.orderType, nextAvailableTime, hotel]);

  function hasModalBeenShown() {
    return localStorage.getItem("categoryModalShown") === "true";
  }

  const handleClose = () => {
    setOrderTypeModal(false);
  };

  const onSelectOrderType = (orderType) => {
    localStorage.setItem("orderType", orderType);
    setFormValues({
      ...formValues,
      orderType: orderType,
      customer_address: null,
      customer_city: null,
      customer_zipcode: null,
    });
    dispatch(clearLocation());
    if (cart?.selectedCoupon?.id) {
      RemoveItemCoupon(cart?.selectedCoupon);
    }

    dispatch(clearCoupon());
    dispatch(resetWallet());
    resetWalletProducts(2);
  };

  useEffect(() => {
    if (hotel?.menu_popup_auto === 1 && !hasModalBeenShown()) {
      setModal(true);
      setIsCollapse(true);
      localStorage.setItem("categoryModalShown", "true");
    }
  }, [hotel]);

  const onDateAndTimeSelect = (deliveryType, deliveryTime) => {
    setFormValues({
      ...formValues,
      deliveryType: deliveryType,
      deliveryTime: deliveryTime,
    });
  };

  return (
    <div className={clsx(classes.filterBarContainer, classes.bgColor)}>
      {hotel?.isCategoryBar === 1 ? (
        <div className={classes.categoryDiv}>
          <div className={isMobile ? classes.rightMobileDiv : classes.rightDiv}>
            {/* <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setModal(true);
                setIsCollapse(true);
              }}
              startIcon={<List style={{ fontSize: "2rem" }} />}
              //  endIcon={endIcon || null}
              className={isMobile ? classes.catMobileBtn : classes.catBtn}
            /> */}
            <div
              className={
                isSearchBarVisible && !isMobile
                  ? classes.leftExpandedDiv
                  : isSearchBarVisible && isMobile
                  ? classes.leftMobileDiv
                  : classes.leftDiv
              }
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => setSearchBarVisible(!isSearchBarVisible)} // Toggle search bar visibility
                startIcon={<SearchIcon style={{ fontSize: "2rem" }} />}
                className={classes.searchBtn}
              />
              {isSearchBarVisible && ( // Conditionally render the search bar
                <InputBase
                  value={searchPhrase}
                  onChange={onSearch}
                  placeholder="Search"
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      event.target.blur();
                    }
                  }}
                  className={
                    isMobile ? classes.searchMobileDiv : classes.searchDiv
                  }
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  inputProps={{ "aria-label": "search" }}
                />
              )}
            </div>
            {!isSearchBarVisible && (
              <Paper
                ref={containerRef}
                className={
                  isMobile && isSearchBarVisible
                    ? classes.scrollbarMobileDiv
                    : isMobile && !isSearchBarVisible
                    ? classes.scrollbarScrollMobileDiv
                    : classes.scrollableDiv
                }
              >
                {menu?.comboCategories
                  ?.filter((item, index, self) => {
                    // Ensure the item has cat_mappings and is the first instance of this category
                    const isUniqueCategory =
                      item?.cat_mappings &&
                      item.cat_mappings.length > 0 &&
                      self.findIndex(
                        (i) => i?.combo_cat_id === item?.combo_cat_id
                      ) === index;

                    // Use the new checkGroupedAvailability function to check if any combo in the group is available
                    return (
                      isUniqueCategory &&
                      checkGroupedAvailability(
                        item.combo_cat_id,
                        self,
                        cart?.checkoutDetails?.deliveryType,
                        cart?.checkoutDetails?.deliveryTime,
                        currentTime
                      )
                    );
                  })
                  .map((c) => (
                    <div
                      ref={(el) => (itemRefs.current[c.combo_cat_id] = el)}
                      key={c.combo_id}
                      data-id={c.combo_cat_id}
                      className={clsx(
                        classes.item,
                        (selectedItem == c.combo_cat_id ||
                          activeItem == c?.combo_cat_id) &&
                          classes.boldText,
                        !checkComboCatAvailability(
                          c,
                          cart?.checkoutDetails?.deliveryType === "ASAP"
                            ? currentTime
                            : formatDateToCheck(
                                cart?.checkoutDetails?.deliveryTime
                              )
                        ) && classes.disabledItem
                      )}
                      onClick={() => {
                        setMenuCategory(c.category_name);
                        setSelectedItem(c.category_name);
                      }}
                    >
                      {c?.category_name}
                    </div>
                  ))}
                {menu.category
                  .filter((c) => c?.item && c.item.length > 0)
                  .filter(
                    (c) =>
                      checkCategoryAndProductAvailability(
                        c,
                        currentTime,
                        cart?.checkoutDetails
                      ) // Only include if available
                  )
                  .map((c, i) => (
                    <div
                      ref={(el) => (itemRefs.current[c.categoryId] = el)}
                      key={c?.categoryId}
                      data-id={c.categoryId}
                      className={clsx(
                        classes.item,
                        (selectedItem === c.categoryId ||
                          activeItem == c?.categoryId) &&
                          classes.boldText,
                        !checkCategoryAndProductAvailability(
                          c,
                          currentTime,
                          cart?.checkoutDetails
                        ) && classes.disabledItem
                      )}
                      onClick={() => {
                        setMenuCategory(c.categoryId);
                        setSelectedItem(c.categoryId);
                      }}
                    >
                      {c.label}
                    </div>
                  ))}
              </Paper>
            )}
          </div>
        </div>
      ) : (
        <>
          <div className={clsx("container", "p-0", classes.sectionDesktop)}>
            <Btn
              text={"Categories"}
              handleClick={() => {
                setModal(true);
                setIsCollapse(true);
              }}
              // handleClick={openModalBox}
              endIcon={<ExpandMoreOutlinedIcon />}
              className={classes.btn}
            />
            {hotel?.items_sorting ? (
              <Btn
                text={FType}
                endIcon={
                  filterDrawer ? (
                    <ExpandLessOutlinedIcon />
                  ) : (
                    <ExpandMoreOutlinedIcon />
                  )
                }
                className={classes.btn}
                onClick={() => onOpenFilterDrawer()}
              />
            ) : (
              ""
            )}
            {!tableId && (
              <Btn
                text={selectedOrderType || "Select Order Type"}
                endIcon={
                  drawer && filterOrderType === TYPES.ORDER_TYPE ? (
                    <ExpandLessOutlinedIcon />
                  ) : (
                    <ExpandMoreOutlinedIcon />
                  )
                }
                className={classes.btn}
                // onClick={() => onOpenDrawer(TYPES.ORDER_TYPE)}
                onClick={() => setOrderTypeModal(true)}
              />
            )}

            {tableId && (
              <Btn
                text={"Tableside order"}
                // endIcon={
                //   drawer && filterOrderType === TYPES.ORDER_TYPE ? (
                //     <ExpandLessOutlinedIcon />
                //   ) : (
                //     <ExpandMoreOutlinedIcon />
                //   )
                // }
                className={classes.btn}
                // onClick={() => onOpenDrawer(TYPES.ORDER_TYPE)}
              />
            )}

            {/* {nextAvailableTime && (
              <Typography className={classes.nextAvailable} variant="h3">
                {nextAvailableTime}
              </Typography>
            )} */}
            {/* <CategoryModal
          open={openModal}
          handleClose={closeModal}
          triggerElement={buttonRef.current}
        /> */}
          </div>
          <div className={classes.sectionMobile}>
            {/* <Btn
          text={FType}
          endIcon={
            filterDrawer ? (
              <ExpandLessOutlinedIcon />
            ) : (
              <ExpandMoreOutlinedIcon />
            )
          }
          className={classes.btn}
          onClick={() => onOpenFilterDrawer()}
        /> */}
            {/* <Btn
          text={"View Menu"}
          handleClick={() => {
            setModal(true);
          }}
          endIcon={<ExpandMoreOutlinedIcon />}
          className={classes.mobileBtn}
        /> */}
            {!tableId && (
              <Btn
                text={selectedOrderType || "-"}
                endIcon={
                  drawer && filterOrderType === TYPES.ORDER_TYPE ? (
                    <ExpandLessOutlinedIcon />
                  ) : (
                    <ExpandMoreOutlinedIcon />
                  )
                }
                className={classes.btn}
                onClick={() => onOpenDrawer(TYPES.ORDER_TYPE)}
              />
            )}

            {tableId && (
              <Btn
                text={"Tableside order"}
                // endIcon={
                //   drawer && filterOrderType === TYPES.ORDER_TYPE ? (
                //     <ExpandLessOutlinedIcon />
                //   ) : (
                //     <ExpandMoreOutlinedIcon />
                //   )
                // }
                className={classes.btn}
                // onClick={() => onOpenDrawer(TYPES.ORDER_TYPE)}
              />
            )}
            {nextAvailableTime && (
              <Typography className={classes.nextAvailable} variant="h3">
                {nextAvailableTime}
              </Typography>
            )}
          </div>
        </>
      )}

      <Drawer
        className={classes.drawer}
        variant="temporary"
        anchor="right"
        open={drawer}
        onClose={() => toggleDrawer(false)}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.filterDrawerContainer}>
          <Typography className={classes.filterDrawerTitle} variant="h3">
            {(filterOrderType === TYPES.ORDER_TYPE && "Im ordering for") ||
              (filterOrderType === TYPES.PAYMENT_METHOD && "Payment options")}
          </Typography>

          <Grid container spacing={2}>
            {filterOrderType === TYPES.ORDER_TYPE &&
              getOrderTypes.map((opt, i) => (
                <Grid item key={i} xs={12} sm={12}>
                  <ChoiceItem
                    // disabled={!opt.active}
                    isOrderType={true}
                    title={opt.title}
                    type={opt.type}
                    value={opt.type}
                    selected={formValues.orderType === opt.type}
                    handleClick={(val) => applyOrderFilter("orderType", val)}
                  />
                </Grid>
              ))}
            {filterOrderType === TYPES.PAYMENT_METHOD &&
              getPaymentMethods.map((opt, i) => (
                <Grid item key={i} xs={12} sm={12}>
                  <ChoiceItem
                    disabled={!opt.active}
                    title={opt.title}
                    type={opt.type}
                    value={opt.type}
                    selected={formValues.paymentMethod === opt.type}
                    handleClick={(val) =>
                      applyOrderFilter("paymentMethod", val)
                    }
                  />
                </Grid>
              ))}
          </Grid>
        </div>
      </Drawer>
      {/* filter drawer */}
      <Drawer
        className={classes.drawer}
        variant="temporary"
        anchor="right"
        open={filterDrawer}
        onClose={() => toggleFilterDrawer(false)}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.filterDrawerContainer}>
          <Typography className={classes.filterDrawerTitle} variant="h3">
            Sort By
          </Typography>

          <Grid container spacing={2}>
            {SORT_OPTIONS?.map((f) => (
              <Grid item xs={12} sm={12} key={f.label}>
                <ChoiceItem
                  // disabled={!opt.active}
                  title={f.label}
                  type={f.label}
                  value={f.value}
                  selected={FType === f.value}
                  handleClick={(val) => applyFilter(val)}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      </Drawer>
      <Modal
        open={orderTypeModal}
        customView={true}
        modelContainer={
          isMobile
            ? classes.orderTypeModalMobileContainer
            : classes.orderTypeModalContainer
        }
      >
        <div className={classes.orderTypeModal}>
          <SelectOrderType
            value={formValues.orderType}
            onSelect={onSelectOrderType}
            formValues={formValues}
            handleClose={handleClose}
            onDateAndTimeSelect={onDateAndTimeSelect}
          />
                      {/* <SelectOrderTypeUI
              orderTypes={getOrderTypes}
              selectedOrderType={formValues.orderType}
              orderTimeType="ASAP"
              onOrderTypeClick={onSelectOrderType}
              onContinueClick={handleClose}
            /> */}
        </div>
      </Modal>
      <Modal
        title={"Main Menu"}
        open={openModal}
        handleClose={() => setModal(false)}
        isCollapse={isCollapse}
      >
        <Menu closeModal={() => setModal(false)} />
      </Modal>
    </div>
  );
};
export default FilterBar;
